export default {
  data() {
    return {
      selectedIds: [],
      restoringSelection: false
    }
  },
  computed: {
    selectedCount() {
      return this.selectedIds.length
    }
  },
  methods: {
    handleSelectionChange(rows) {
      if (this.restoringSelection) return
      const pageIds = (this.list || []).map(item => item.id)
      const selectedOnPage = rows.map(item => item.id)
      const retainedIds = this.selectedIds.filter(id => !pageIds.includes(id))
      this.selectedIds = Array.from(new Set(retainedIds.concat(selectedOnPage)))
    },
    restoreSelection() {
      const table = this.$refs.dataTable
      if (!table) return
      this.restoringSelection = true
      table.clearSelection()
      ;(this.list || []).forEach(row => {
        if (this.selectedIds.includes(row.id)) {
          table.toggleRowSelection(row, true)
        }
      })
      this.$nextTick(() => {
        this.restoringSelection = false
      })
    },
    clearSelected() {
      this.selectedIds = []
      const table = this.$refs.dataTable
      if (table) {
        this.restoringSelection = true
        table.clearSelection()
        this.$nextTick(() => {
          this.restoringSelection = false
        })
      }
    },
    removeSelected(id) {
      if (id == null) return
      this.selectedIds = this.selectedIds.filter(selectedId => selectedId !== id)
      const table = this.$refs.dataTable
      const row = (this.list || []).find(item => item.id === id)
      if (table && row) {
        this.restoringSelection = true
        table.toggleRowSelection(row, false)
        this.$nextTick(() => {
          this.restoringSelection = false
        })
      }
    }
  }
}
